/**
 * Single source of truth for the production site URL.
 * Used in canonical tags, OG tags, JSON-LD, sitemap, and all external-facing URLs.
 *
 * Must match the actual deployed origin — currently the Cloudflare Workers
 * deployment at `orbrasil.milgrom.com.br`. The bare `orbrasil.com.br` is a
 * different (Apache/PHP) site outside this repo's deploy chain; pointing
 * canonicals there would tell Google the content lives somewhere we don't
 * own and would route social-share previews into the wrong origin.
 *
 * Update this AND scripts/generate-sitemap.mjs together if the production
 * domain changes — the sitemap script is run from a Node context that can't
 * import this module via tsx, so it duplicates the constant on purpose.
 */
export const SITE_URL = "https://orbrasil.milgrom.com.br";
